import valid from 'card-validator'

type CardNumberVerification = ReturnType<typeof valid.number>
type CreditCardType = NonNullable<CardNumberVerification['card']>

export const validNumber: typeof valid.number = (cardNumber, options = {}) =>
  valid.number(cardNumber, {
    ...options,
    luhnValidateUnionPay: true
  })

export const validExpirationDate: typeof valid.expirationDate = (expirationDate, maxYear) =>
  valid.expirationDate(expirationDate, maxYear)

export const validCvv: typeof valid.cvv = (securityCode, maxLength = 3) =>
  valid.cvv(securityCode, maxLength)

type MaskFunc = (card: CreditCardType, mask?: string) => string

export const generateCardMask: MaskFunc = ({ gaps, lengths }, mask = '9') => {
  let finalMask = ''
  for (let i = 0; i < lengths[lengths.length - 1]; i++) {
    finalMask += mask
    if (gaps.includes(i + 1)) {
      finalMask += ' '
    }
  }
  return finalMask
}

export const formatExpiry = (exp?: string): string => {
  if (!exp) return ''
  const count = exp.length
  const monthEnd = count - 2
  const month = exp.substring(0, monthEnd)
  const year = exp.substring(monthEnd, count)
  return `${month} / ${year}`
}
